import { useEffect, useState, useMemo, useRef } from 'react';
import { Card, Row, Col, Form, Input } from 'antd';
import { useHistory, useLocation } from "react-router-dom";
import { headerStyle } from 'shared/styles/baseStyle';
import  EndPoints from 'shared/endPoints/EndPoints.json';
import PackingListResults from '../PackingListResults';
import { layout, ParcelAndPacking, SearchAndNewPacking } from './SearchPacking';

export default function SearchPackingListBl({isDeviceConfiguration}) {
    const history = useHistory();
    const { search } = useLocation()
    const queryParams = useMemo(() => new URLSearchParams(search), [search])
    const [endPoint, setEndPoint] = useState()
    const myRef = useRef();
    const [form] = Form.useForm(); 
    const blTypeId= 3;

    const navigateToNewPackingList = () => {
        history.push({pathname:'/choices/new-packageBl',state:'Bl'}) 
    } 
    useEffect(() => {
        form.setFieldsValue({
            'deviceImei': queryParams.get('deviceImei'), 
            'parcelId': queryParams.get('parcelId'),
            'PackingStatusId': queryParams.get('PackingStatusId'),
        })
        setEndPoint(`${EndPoints.PACKING.GETPACKINGLISTBLUETOOTH}?DeviceTypeId=${blTypeId}&${queryParams.toString()}`);
    }, [queryParams, form])

    const onFinish =(fieldsValues) => {
        const executeScroll = () => myRef.current.scrollIntoView({ behavior: 'smooth' });
        const values = {
            ...fieldsValues,
        }
        Object.keys(values).forEach(key => values[key] === null || values[key] === undefined || values[key] === '' ? delete values[key] : values[key]);
        const params = new URLSearchParams(values);
        history.replace({ search: `?${params}` });
        setEndPoint(`${EndPoints.PACKING.GETPACKINGLISTBLUETOOTH}?DeviceTypeId=${blTypeId}&${params}`);
        executeScroll();
    }


    return (
        <>
            <Card type="inner" headStyle={headerStyle} title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση">
              {!isDeviceConfiguration && <SearchAndNewPacking navigateToNewPackingList={navigateToNewPackingList}/>}
                <Form form={form} onFinish={onFinish} {...layout} >
                    <Row>
                        <Col span={12}>
                            <Form.Item
                                name="deviceImei"
                                label="ΙΜΕΙ Συσκευής:"
                                rules={[
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>               
                        <ParcelAndPacking isDeviceConfiguration={isDeviceConfiguration}/>                     
                    </Row>
                </Form>
            </Card>
            <Col ref={myRef}>
                <PackingListResults endPoint={endPoint} deviceTypeId={blTypeId} />
            </Col>
        </>
    );
}